import { Box, Typography } from "@mui/material";
import { translate } from "../../../../../translate/translate";
import { CHECKLIST_PHASE_LEGEND_ITEMS } from "../constants/dashboard.constants";

const NpiChecklistLegendComponent = () => (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, width: "auto" }} id={"dashboard-legenda"}>
        <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#94A3B8" }}>
            {translate.t("legend").toUpperCase()}:
        </Typography>
        {CHECKLIST_PHASE_LEGEND_ITEMS.map((item) => (
            <Box key={item.label} sx={{ display: "flex", alignItems: "center", gap: 0.75, width: "auto", flexShrink: 0 }}>
                <Box sx={{ width: 10, height: 10, flexShrink: 0, borderRadius: "50%", backgroundColor: item.color }} />
                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "#64748B", whiteSpace: "nowrap" }}>{translate.t(item.label)}</Typography>
            </Box>
        ))}
    </Box>
);

export default NpiChecklistLegendComponent;
